'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshCookie = undefined;

var _noAuthApiClient = require('./clients/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _core = require('./middlewares/core');

var _promise = require('./helpers/promise');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hubapi = (0, _core.standardApi)('api', 'hubapi');
var hubspot = (0, _core.standardApi)('api', 'hubspot');

var refreshCookieForApi = function refreshCookieForApi(portalId, api, withNoCacheHeader) {
  var headers = {
    'X-Force-Cookie-Refresh': true
  };

  if (withNoCacheHeader) {
    headers['X-Force-Cookie-Refresh-No-Cache'] = true;
  }

  var query = portalId ? { portalId: portalId } : {};
  var path = '/login-api/v1/cookie-refresh' + (portalId ? '' : '/hubless');
  return _noAuthApiClient2.default.get(path, {
    api: api,
    headers: headers,
    withCredentials: true,
    query: query
  });
};

var refreshCookie = exports.refreshCookie = function refreshCookie(portalId) {
  var withNoCacheHeader = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var refreshHubApi = refreshCookieForApi(portalId, hubapi, withNoCacheHeader);
  var refreshHubSpot = refreshCookieForApi(portalId, hubspot, withNoCacheHeader);
  return _promise.Promise.all([refreshHubApi, refreshHubSpot]);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.193/js/auth.js
// module id = 366
// module chunks = 3 4 5